var _circle, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreathingDashboardSelected(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    fill: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_700_571",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 18,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 18,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_700_571)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5556 25.4444H18.3333V21H16.5556V25.4444ZM23.6667 25.4444H25.4444V16.5556H23.6667V25.4444ZM20.1111 25.4444H21.8889V22.7778H20.1111V25.4444ZM20.1111 21H21.8889V19.2222H20.1111V21ZM14.7778 29C14.2889 29 13.8704 28.8259 13.5222 28.4778C13.1741 28.1296 13 27.7111 13 27.2222V14.7778C13 14.2889 13.1741 13.8704 13.5222 13.5222C13.8704 13.1741 14.2889 13 14.7778 13H27.2222C27.7111 13 28.1296 13.1741 28.4778 13.5222C28.8259 13.8704 29 14.2889 29 14.7778V27.2222C29 27.7111 28.8259 28.1296 28.4778 28.4778C28.1296 28.8259 27.7111 29 27.2222 29H14.7778ZM14.7778 27.2222H27.2222V14.7778H14.7778V27.2222Z",
    fill: "#3474E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreathingDashboardSelected);
export default __webpack_public_path__ + "static/media/breathing_dashboard_selected.d5f913aa1dbf68a89924872eda80ab9d.svg";
export { ForwardRef as ReactComponent };